import React from 'react';
import { Text } from '@pairy/pds-react';

import * as TabsStyled from '../../../../../../styles/Tabs.styles';

import * as Styled from './index.styles';

const tabValues = {
  newClient: { name: '새로운 고객' },
  existingClient: {
    name: '저장된 고객',
  },
} as const;

interface Props {
  newClient: React.ReactNode;
  existingClient: React.ReactNode;
}

const ClientTabs = ({ newClient, existingClient }: Props) => {
  return (
    <Styled.TabsRoot defaultValue={tabValues.newClient.name}>
      <Text variant="md-semibold" marginBottom={8}>
        누구에게 보내실 건가요?
      </Text>
      <TabsStyled.TabsList>
        {Object.values(tabValues).map(({ name }) => (
          <TabsStyled.TabsIdContainer key={name}>
            <TabsStyled.TabsTrigger value={name} key={name}>
              {name}
            </TabsStyled.TabsTrigger>
          </TabsStyled.TabsIdContainer>
        ))}
      </TabsStyled.TabsList>
      <TabsStyled.TabsContent value={tabValues.newClient.name}>
        {newClient}
      </TabsStyled.TabsContent>
      <TabsStyled.TabsContent
        value={tabValues.existingClient.name}
        height="calc(100% - 123px)"
      >
        {existingClient}
      </TabsStyled.TabsContent>
    </Styled.TabsRoot>
  );
};

export default ClientTabs;
